import { Box } from "@chakra-ui/react";

import type { IVideo } from "../../../../../utils/types";

import styles from "./GuideContentBody.module.scss";

interface VideoContentProps {
  field: IVideo;
}

export default function VideoContent({ field }: VideoContentProps) {
  return (
    <Box
      {...field.styles?.container}
      className={styles.videoContainer}
      data-testid={`video-${field.src}`}
    >
      <video
        src={field.src}
        controls
        controlsList="nodownload"
        muted
        playsInline
        style={{
          width: "100%",
          height: "auto",
          aspectRatio: "4 / 5",
          ...field.style,
        }}
      >
        <track default kind="captions" srcLang="en" src={field.src} />
      </video>
    </Box>
  );
}
